import axios from 'axios';
import type { IAppointmentConfig } from '@bb/domain/dist/types';

type SaveConfigParams = {
  listingId: string;
};

type SaveConfigBody = {
  config: Partial<IAppointmentConfig>;
  accessHours?: todo;
};

const saveConfig = async (params: SaveConfigParams, body: SaveConfigBody) => {
  await axios.request({
    url: `/listing/${params.listingId}/appointments/config`,
    method: 'post',
    data: body,
  });
};

export default saveConfig;
